









import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'AppFooter',
})
export default class AppFooter extends Vue {
  private appTitle: string = process.env.VUE_APP_TITLE;
}
